import React from "react";
import type { RouteComponentProps } from "react-router-dom";
import AdvanceSearch from "@modules/advance-search/AdvanceSearch";
import AdvanceSearchClassroom from "@dimensions/classroom/advance-search";
import AdvanceSearchInstructor from "@dimensions/instructor/advance-search";
import AdvanceSearchPopulation from "@dimensions/population/advance-search";
import AdvanceSearchCourse from "@dimensions/course/advance-search";
import AdvanceSearchSection from "@dimensions/section/advance-search";
import AdvanceSearchGroup from "@dimensions/group/advance-search";
import AdvanceSearchLink from "@dimensions/link/advance-search";
import AdvanceSearchPackage from "@dimensions/package/advance-search";
import { createAdvanceSearchDimensionRegistry } from "./advanceSearchRegistry";

/** Stable shell-owned registry injected into the generic advanced-search page. */
export const ADVANCE_SEARCH_DIMENSION_COMPONENTS = createAdvanceSearchDimensionRegistry({
  classroom: AdvanceSearchClassroom,
  instructor: AdvanceSearchInstructor,
  population: AdvanceSearchPopulation,
  course: AdvanceSearchCourse,
  section: AdvanceSearchSection,
  group: AdvanceSearchGroup,
  link: AdvanceSearchLink,
  package: AdvanceSearchPackage,
});

/** Route composition boundary for the generic page and dimension-owned implementations. */
const AdvanceSearchRoute: React.FC<RouteComponentProps> = props => (
  <AdvanceSearch {...props} dimensionComponents={ADVANCE_SEARCH_DIMENSION_COMPONENTS} />
);

export default AdvanceSearchRoute;
